import MusicUpload from "components/MusicUpload";
import {useContext, useEffect} from "react";
import {PageTitleContext} from "context/PageTitleContext";
import {CrumbsContext} from "context/CrumbsContext";

export default function Uploads() {
    let {setTitle} = useContext(PageTitleContext)
    let {setCrumbs} = useContext(CrumbsContext)

    useEffect(() => {
        setTitle('Music Uploads')
        setCrumbs([{'name': 'Library', 'link': '/library'}, {'name': 'Digital Library', 'link': '/library'}])
    }, [])

    return <>
        <div className="min-h-full px-5 py-0 mt-0 h-screen">
            <div className="mt-2">
                <MusicUpload/>
            </div>
        </div>
    </>
}
